<template>
  <!-- before login -->
  <main class="main">
    <article>
      <section class="popup-header-option">
        <p class="text__main text24 sentence__600">{{ $t("chart2.chart") }}</p>
        <ComboBox
          :items="chartComboItems"
          :width="'32rem'"
          :height="`32px`"
          :hasSearch="true"
          @onChange="chartComboChangeHandler"
        />
      </section>

      <section class="popup-chart-container">
        <div
          class="popup-chart-wrapper"
          v-for="item in displayedCoins"
          :key="item"
        >
          <div class="header">
            <img :src="`${getImageSrc(item)}`" alt="" />
            <p class="text__main text24 sentence__600">{{ item }}</p>
          </div>
          <lazyMetaChart
            v-if="chartType === 'meta' || chartType === 'all'"
            :ticker="item"
            :isPopupOpen="true"
            :isAll="chartType === 'all'"
            :subscribeInfo="chartSubScribeInfo.subsc_type"
            model="meta"
          ></lazyMetaChart>
          <lazyMetaChart
            @mounted="renderHandler(element.key)"
            :ticker="item"
            v-if="chartType == 'alpha'"
            :isPopupOpen="true"
            :key="item"
            :subscribeInfo="chartSubScribeInfo.subsc_type"
            model="alpha"
          ></lazyMetaChart>
          <lazyMetaChart
            @mounted="renderHandler(element.key)"
            :ticker="item"
            v-if="chartType == 'kibotZone'"
            :isPopupOpen="true"
            :key="item"
            :subscribeInfo="chartSubScribeInfo.subsc_type"
            :currentStrategy="'kibotZone'"
            model="kibotZone"
          ></lazyMetaChart>
          <lazyMetaChart
            @mounted="renderHandler(element.key)"
            :ticker="item"
            v-if="chartType == 'cross'"
            :isPopupOpen="true"
            :key="item"
            :subscribeInfo="chartSubScribeInfo.subsc_type"
            :currentStrategy="'cross'"
            model="cross"
          ></lazyMetaChart>
          <lazyMetaChart
            @mounted="renderHandler(element.key)"
            :ticker="item"
            v-if="chartType == 'double'"
            :isPopupOpen="true"
            :key="item"
            :subscribeInfo="chartSubScribeInfo.subsc_type"
            :currentStrategy="'double'"
            model="double"
          ></lazyMetaChart>
          <lazyScoreChart
            v-if="chartType === 'score'"
            :ticker="item"
          ></lazyScoreChart>
          <lazyTradingview
            v-if="chartType === 'trading_view'"
            :ticker="item"
          ></lazyTradingview>
        </div>
      </section>
      <div ref="loadingTrigger" class="loading"></div>
    </article>
  </main>
</template>

<script setup>
import {
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  nextTick,
  computed,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import ComboBox from "@/components/ComboBox.vue";
import { getScoreListData, getScoreSignalData } from "@/api/chart/scoreApi";
const lazyMetaChart = defineAsyncComponent(() =>
  import("@/components/chart/meta-chart/MetaChartCopy.vue")
);
const lazyTradingview = defineAsyncComponent(() =>
  import("@/components/chart/tradingview/TradingView.vue")
);
const lazyScoreChart = defineAsyncComponent(() =>
  import("@/components/chart/score-chart/ScoreChart.vue")
);
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n({ useScope: "global" });
// const resizeEmit = (widthSize, chartDom) => {
//   if (widthSize > 768) {
//     chartDom.style.width = `${widthSize / 2 - 110}px`;
//   } else {
//     chartDom.style.width = `${widthSize - 100}px`;
//   }
// };

let ticker = ref("");

const allTicker = ref(null);
const coinCombo = ref(null);
const coinComboList = ref({
  isActive: false,
  title: "Select Coins",
  titleStyle: {
    width: "250px",
    margin: "0 auto",
  },
  items: coinCombo.value,
});

const store = useStore();
const route = useRoute();
const getCoinInfo = ref("");

const loadingTrigger = ref(null);
// const exceptList = useRoute().query?.t?.split(",") || [];
// const coinList = useCoinListStore()
//   .getFavoriteCoinList_2()
//   ?.filter((ob) => !exceptList.includes(ob?.coin_code));

const coinList = useRoute().query?.t?.split(",") || [];
let chartSubScribeInfo = computed(() => store.state.userInfo.chartInfo);

const displayedCoins = ref([]);
const itemsPerPage = 2;
const page = ref(0);
const chartType = ref("all");
const chartComboItems = [
  { key: "all", value: "chart1.multiChart", selected: true, active: true },
  { key: "meta", value: "chart1.metaChart", selected: false, active: false },
  { key: "alpha", value: "menu.alphaChart", selected: false, active: false },
  { key: "score", value: "chart1.scoreChart", selected: false, active: false },
  {
    key: "kibotZone",
    value: "1%chart",
    selected: false,
    active: false,
  },
  { key: "cross", value: "Cross Chart", selected: false, active: false },
  // { key: "double", value: "Double Chart", selected: false, active: false },
  // {
  //   key: "trading_view",
  //   value: "chart1.tradingView",
  //   selected: false,
  //   active: false,
  // },
];
const refs = ref({});
const chartComboChangeHandler = async ({ selected }) => {
  chartType.value = selected.key;
  _resetDisplay();
};

const _resetDisplay = () => {
  page.value = 0;
  displayedCoins.value = [];
  _loadMoreCoins();
  window.scrollTo(0, 0);
};

function getImageSrc(value) {
  const baseUrl =
    "https://risingx-wedatalab.s3.ap-northeast-2.amazonaws.com/static/coin_icon/";
  const imgSrc = `${baseUrl}${value}.png`;

  // 이미지가 제대로 로드되지 않으면 기본 이미지로 대체
  return imgSrc || `${baseUrl}default.png`;
}

// const allKeys = coinCombo.value.map((coin) => coin.key);

// const _loadMoreCoins = () => {
//   const start = page.value * itemsPerPage;
//   const end = start + itemsPerPage;
//   if (chartType.value == "all") {
//     displayedCoins.value.push(...allTicker.value.map((coin) => coin.ticker));
//     // displayedCoins.value.push(...coinList.slice(start, end));
//   } else {
//     displayedCoins.value.push(...coinList.slice(start, end));
//   }

//   page.value += 1;
//   nextTick(() => {
//     for (const key in refs.value) {
//       if (refs.value[key] && refs.value[key].metaChart) {
//         refs.value[key].metaChart.resize();
//       }
//     }
//   });
// };

const _loadMoreCoins = () => {
  // 1. chartType에 따라 사용할 데이터 소스를 결정합니다.
  // 'all'일 경우 allTicker에서 티커 리스트를, 아닐 경우 coinList를 사용합니다.
  const sourceList =
    chartType.value === "all"
      ? allTicker.value.map((coin) => coin.ticker)
      : coinList;

  // 데이터 소스가 준비되지 않았거나 비어있으면 함수를 종료합니다.
  if (!sourceList || sourceList.length === 0) return;

  const start = page.value * itemsPerPage;
  const end = start + itemsPerPage;

  // 2. 소스 리스트에서 현재 페이지에 해당하는 부분만 잘라냅니다.
  const newItems = sourceList.slice(start, end);

  // 3. 더 이상 불러올 아이템이 없으면 함수를 종료합니다. (무한 루프 방지)
  if (newItems.length === 0 && page.value > 0) {
    return;
  }

  // 4. 잘라낸 아이템들을 displayedCoins에 추가하고 페이지 번호를 증가시킵니다.
  displayedCoins.value.push(...newItems);
  page.value += 1;

  // 5. 차트 리사이즈를 위한 nextTick 로직은 그대로 유지합니다.
  nextTick(() => {
    for (const key in refs.value) {
      if (refs.value[key] && refs.value[key].metaChart) {
        refs.value[key].metaChart.resize();
      }
    }
  });
};

const setObserverEvent = () => {
  function _handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        _loadMoreCoins();
      }
    });
  }

  const observer = new IntersectionObserver(_handleIntersection);
  if (loadingTrigger.value) {
    observer.observe(loadingTrigger.value);
  }
};
let result = ref();
let signal_result = ref();

onMounted(async () => {
  coinCombo.value = await store.dispatch("getCoinList/fetchCoin");
  // allTicker.value = store.state.getCoinList.coinAllList;

  // console.log(allTicker.value);

  ticker.value = await store.dispatch(
    "getCoinList/getChartSubscribeDefaultCoin"
  );

  let coin_list = await store.dispatch("getCoinList/getCoinList");
  result.value = await getScoreListData(); // symbol => usdt 붙음  , ticker : 코인명만
  signal_result.value = await getScoreSignalData(); // ticker => usdt붙음

  result.value.forEach((resultArray) => {
    let signalArray = signal_result.value.find(
      (data) => data.ticker == resultArray.symbol
    );

    if (signalArray) {
      resultArray.signal = signalArray.signal;
    }
  });

  allTicker.value = result.value.filter((resultItem) =>
    coin_list.some(
      (coin) => coin.coin_code === resultItem.symbol.replace(/USDT$/, "")
    )
  );

  allTicker.value.sort((a, b) => {
    // coin_list에서 a와 b의 coin_code 순서를 찾아 비교하여 정렬
    let aIndex = coin_list.findIndex(
      (coin) => coin.coin_code === a.symbol.replace(/USDT$/, "")
    );
    let bIndex = coin_list.findIndex(
      (coin) => coin.coin_code === b.symbol.replace(/USDT$/, "")
    );
    return aIndex - bIndex;
  });

  window.scrollTo(0, 0);
  setObserverEvent();
  _loadMoreCoins();

  const urlParams = new URLSearchParams(window.location.search);
  const localeParam = urlParams.get("locale");
  if (localeParam) {
    locale.value = localeParam; // 전달된 locale로 설정
  }
});

watch(coinCombo, (newVal) => {
  coinComboList.value.items = newVal;
});
watch(ticker, (newVal) => {
  ticker.value = newVal;

  getCoinInfo.value = coinComboList.value.items.find(
    (option) => option.key == ticker.value
  );
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/kibot/chart_popup.scss";
@import "@/assets/scss/pages/kibot/chart.scss";
@import "@/assets/scss/layouts/default.scss";
</style>
